import { Tag } from '@/pages/CustomCenter/ExtractConfig/components/workflow/components/extract-tag-select';
import { FormType } from './index';

export const convertTo = <T extends FormType['tags']>(
  originTags?: Tag[],
): T => {
  const dto = {
    text_tags: [],
    table_tags: [],
  } as any as T;

  originTags?.forEach((item) => {
    if (item.type === 'text') {
      dto.text_tags.push({
        tag_code: item.value,
        tag_name: item.label,
      });
    } else if (item.type === 'table') {
      let tableTag = dto.table_tags.find(
        (t) => t.table_code === item.table_code,
      );
      if (!tableTag) {
        tableTag = {
          table_code: item.table_code!,
          table_name: item.table_name!,
          tags: [],
        };
        dto.table_tags.push(tableTag);
      }
      tableTag.tags.push({
        tag_code: item.value,
        tag_name: item.label,
      });
    }
  });

  return dto;
};

export const convertFrom = <T extends FormType['tags']>(
  originTags: T,
): string[] => {
  const tags = [] as string[];

  originTags?.text_tags?.forEach((item) => {
    tags.push(item.tag_code);
  });
  originTags?.table_tags?.forEach((item) => {
    item.tags.forEach((tag) => {
      tags.push(tag.tag_code);
    });
  });
  return tags;
};
